// Shared helpers to keep service date selection consistent across booking forms.
// Dates are handled as local "YYYY-MM-DD" strings so they can be compared directly
// and assigned to <input type="date"> min/max/value attributes.

export const toDateStr = (date) => {
    if (!date) return ""
    return date.toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10)
}

// iOS Safari does not enforce the min/max attributes of a native date picker,
// so any selected date must be clamped back into the allowed range manually.
export const clampServiceDate = (value, minDate, maxDate) => {
    if (!value) return minDate || ""
    if (minDate && value < minDate) return minDate
    if (maxDate && value > maxDate) return maxDate
    return value
}

export const isServiceDateOutOfRange = (value, minDate, maxDate) => {
    if (!value) return true
    if (minDate && value < minDate) return true
    if (maxDate && value > maxDate) return true
    return false
}
